import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { FormikSwitch } from "../forms/Formik"

export function ImportFormSettingsPanelContent() {
    return (
        <>
            <LocalizedStrict id="data-import-csv-field-update-identical">
                <FormikSwitch name="updateMatching">Update identical</FormikSwitch>
            </LocalizedStrict>
            <LocalizedStrict id="data-import-csv-field-delete-existing">
                <FormikSwitch name="deleteUnmatched">Delete existing</FormikSwitch>
            </LocalizedStrict>
        </>
    )
}
